/**
 * i18n setup — tg-holdem (mirrors sagwa-box pattern).
 * KO-first: prefers Telegram user.language_code when available.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ko from './locales/ko.json'
import en from './locales/en.json'

function resolveInitialLanguage(): string | undefined {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined
  const code = tg?.initDataUnsafe?.user?.language_code
  if (!code) return undefined
  return code.toLowerCase().startsWith('ko') ? 'ko' : code
}

const initialLng = resolveInitialLanguage()

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
    },
    fallbackLng: 'ko',
    ...(initialLng ? { lng: initialLng } : { lng: 'ko' }),
    supportedLngs: ['ko', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
    },
  })

export default i18n
